import styled from 'styled-components';
import { theme } from '../themes/theme';
const SeparationLine = styled.hr `
  height: 1px;
  width: 100%;
  background-color: ${theme.DirtyWhite};
  margin: 1rem 0;
  border: 0;
  box-shadow: none;
`;
export { SeparationLine };
